import React, { useContext } from "react";
import { Button, Col, Form, Row, Table } from "react-bootstrap";
import helpers from "../../utils/helpers";
import { BiSolidRightArrow } from "react-icons/bi";
import AuthContext from "../../context/AuthContext";
import obj, { headerDataBetHistory } from "../../utils/constants";
import { useState } from "react";
import moment from "moment";
import { capitalize } from "lodash";
import DatePicker from "react-datepicker";

export const BettingHistoryTabNew = ({
  filter,
  setFilter,
  getData,
  data,
  betType,
}) => {
  const { user } = useContext(AuthContext);  const [active, setActive] = useState([]);
  return (
    <div className="common-container">
      <Form>
        <div className="bet_status  p-2 mb-0">
          <Row>
            <Col xxl={12} lg={12} md={12}>
              <Row>
                <Col lg={7} sm={8} className="mb-lg-0 mb-3">
                  <div className="d-flex align-items-center">
                    <div className="bet-sec" style={{ marginRight: "10px" }}>
                      <Form.Label className="">Bet Status:</Form.Label>
                      <Form.Select
                        style={{ minWidth: "100px" }}
                        className="small_select"
                        onChange={(e) =>
                          setFilter({ ...filter, status: e.target.value })
                        }
                        value={filter.status}
                        aria-label="Default select example"
                      >
                        {filter.betType == "betfair" &&
                          (filter.type == 4 ||
                            filter.type == 2 ||
                            filter.type == 1) && (
                            <>
                              {" "}
                              <option value="unmatched">Unmatched</option>
                              <option value="matched">Matched</option>
                            </>
                          )}

                        <option value="completed">Settled</option>
                        <option value="suspend">Cancelled</option>
                        <option value="voided">Voided</option>
                      </Form.Select>
                    </div>
                    <div
                      className="bet-sec bet-period"
                      style={{ marginRight: "10px" }}
                    >
                      <Form.Label className="">Period</Form.Label>
                      <Form.Group className="form-group">
                        <DatePicker
                                                         className="small_form_control"
                                                         selected={
                                                           filter.fromPeriod
                                                             ? new Date(filter.fromPeriod)
                                                             : null
                                                         }
                                                         onChange={(date) =>
                                                           setFilter({
                                                             ...filter,
                                                             fromPeriod: date
                                                               .toISOString()
                                                               .split("T")[0],
                                                             filterByDay: "",
                                                           })
                                                         }
                                                         dateFormat="yyyy-MM-dd"
                                                         maxDate={new Date()}
                                                         showMonthDropdown
                                                         showYearDropdown
                                                         dropdownMode="select" // or "scroll" if you prefer scroll-style dropdowns
                                                         placeholderText="Select a date"
                                                         onFocus={(e) => e.target.blur()}
                                                       />
                        <Form.Control
                          style={{ marginLeft: "10px", width: "47px" }}
                          className="small_form_control"
                          type="text"
                          placeholder="00:00"
                          disabled
                        />
                      </Form.Group>
                    </div>
                    <div className="bet-sec bet-period">
                      <Form.Label className="">To</Form.Label>
                      <Form.Group className="form-group">
                        <DatePicker
                                                        className="small_form_control"
                                                        selected={
                                                          filter.toPeriod
                                                            ? new Date(filter.toPeriod)
                                                            : null
                                                        }
                                                        onChange={(date) =>
                                                          setFilter({
                                                            ...filter,
                                                            toPeriod: date.toISOString().split("T")[0],
                                                            filterByDay: "",
                                                          })
                                                        }
                                                        dateFormat="yyyy-MM-dd"
                                                        minDate={
                                                          filter?.fromPeriod
                                                            ? new Date(filter?.fromPeriod)
                                                                .toISOString()
                                                                .split("T")[0]
                                                            : new Date()
                                                        }
                                                        maxDate={new Date().toISOString().split("T")[0]}
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        dropdownMode="select" // or "scroll" if you prefer scroll-style dropdowns
                                                        placeholderText="Select a date"
                                                        onFocus={(e) => e.target.blur()}
                                                      />
                        <Form.Control
                          style={{ marginLeft: "10px", width: "47px" }}
                          className="small_form_control"
                          type="text"
                          placeholder="23:59"
                          disabled
                        />
                      </Form.Group>
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>

          <div className="history-btn mt-1">
            <ul className="list-unstyled mb-0">
              <li>
                <Button
                  className={"me-0 theme_light_btn"}
                  onClick={(e) =>
                    setFilter({
                      ...filter,
                      filterByDay: "today",
                    })
                  }
                  style={{padding:`0 10px`,lineHeight:`25px`}}
                >
                  Just For Today
                </Button>
              </li>
              <li>
                <Button
                  className={
                    // filter.filterByDay === "yesterday"
                    //   ? "me-0 theme_dark_btn"
                    //   :
                    "me-0 theme_light_btn"
                  }
                  onClick={(e) =>
                    setFilter({
                      ...filter,
                      filterByDay: "yesterday",
                    })
                  }
                  style={{padding:`0 10px`,lineHeight:`25px`}}
                >
                  From Yesterday
                </Button>
              </li>
              <li>
                <Button
                  className="theme_light_btn theme_dark_btn"
                  onClick={() => getData()}
                >
                  Get History
                </Button>{" "}
              </li>
            </ul>
          </div>
        </div>
      </Form>

      {/* {data?.data?.length == 0 ? (
        <div id="noReportMessage">
          <p className="p-0" style={{ marginBottom: "7px" }}>
            Betting History enables you to review the bets you have placed.{" "}
            <br />
            Specify the time period during which your bets were placed, the type
            of markets on which the bets were placed, and the sport.
          </p>
          <p className="p-0" style={{ marginBottom: "7px" }}>
            Betting History is available online for the past 62 days.
          </p>
          <p className="p-0" style={{ marginBottom: "7px" }}>
            User can search up to 14 days records per query only .
          </p>
        </div>
      ) : (
        <div className="account-table batting-table profit_loss_table">
          <div className="responsive table-main-wrapper">
          
               <Table className="table_caption_style w-100">
                <thead>
                  <tr>
                    {headerDataBetHistory.map((res) => {
                      return (
                        <th scope="col" className={res.class} width={res.widht}>
                          {res.title}
                        </th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody>
                  {data?.data?.length > 0 ? (
                    data?.data?.map((item) => {
                      return (
                        <>
                          <tr>
                            <td>
                              <span
                                style={{
                                  color: "#2789ce",
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                {active.includes(item?._id) ? (
                                  <img
                                    style={{
                                      height: "15px",
                                      marginRight: "5px",
                                    }}
                                    onClick={() =>
                                      setActive((prev) => {
                                        return prev?.filter((res) => {
                                          return res !== item?._id;
                                        });
                                      })
                                    }
                                    src={require("../../assets/images/expand-open.png")}
                                  />
                                ) : (
                                  <img
                                    style={{
                                      height: "15px",
                                      marginRight: "5px",
                                    }}
                                    onClick={() =>
                                      setActive((prev) => {
                                        return [...prev, item?._id];
                                      })
                                    }
                                    src={require("../../assets/images/expand-close.png")}
                                  />
                                )}{" "}
                                {item?.matchBetId || item?.sessionBetId}
                              </span>
                            </td>
                            <td>{item?.clientName}</td>
                            <td className="text-start" width="30%">
                              <span style={{ textTransform: "uppercase" }}>
                                {obj.betCheckObj[item?.eventType]}
                              </span>
                              <img
                                class="fromto"
                                src={require("../../assets/images/transparent.gif")}
                              />
                              <strong>{item?.matchName}</strong>
                              <img
                                class="fromto"
                                src={require("../../assets/images/transparent.gif")}
                              />
                              {capitalize(item?.betFaireType) ||
                                item?.fancyName}
                            </td>
                            <td className="text-end">
                              {" "}
                              {filter?.betType === "fancy"
                                ? item?.runnerName
                                : filter?.betType === "sportsbook"
                                ? item?.runnerName
                                : item?.teamName}
                            </td>
                            <td className="text-end">
                              {" "}
                              <span
                                className={
                                  item?.betType == "lay" || item?.type == "No"
                                    ? "lay-bg"
                                    : item?.betType == "back" ||
                                      item?.type == "Yes"
                                    ? "back-bg"
                                    : ""
                                }
                                style={{ textTransform: "capitalize" }}
                              >
                                {item?.betType || item?.type}
                              </span>
                            </td>
                            <td className="text-end">
                              {moment(item?.timeInserted).format(
                                "YYYY-MM-DD hh:mm:ss"
                              )}
                            </td>
                            <td className="text-end">
                              {" "}
                              {betType === "fancy"
                                ? item?.betRun + "/" + item?.bhav
                                : item?.bhav || "N/A"}
                            </td>{" "}
                            <td className="text-end">
                              {" "}
                              {helpers.currencyFormat(item?.amount.toFixed(2)) || "N/A"}
                            </td>
                            <td className="text-end">
                              {" "}
                              {betType === "fancy"
                                ? item?.betRun + "/" + item?.bhav
                                : item?.bhav || "N/A"}{" "}
                            </td>
                            {betType == "betfair" ||
                            betType == "Bookmaker" ||
                            betType == "toss" ||
                            betType == "tie" ? (
                              <td className="text-end">
                                {((item?.teamSelectionWin == item?.selectionId &&
                                  item?.betType == "back") ||
                                (item?.teamSelectionWin != item?.selectionId &&
                                  item?.betType == "lay")) ? (
                                  helpers.currencyFormat(item?.profitAmount)
                                ) : (
                                  <span className="text-danger">
                                    ({helpers.currencyFormat(item?.loseAmount.toFixed(2))})
                                  </span>
                                )}
                              </td>
                            ) : betType === "sportsbook" ? (
                              <td className="text-end">
                                {item?.teamSelectionWin &&
                                item?.teamSelectionWin
                                  .split(",")
                                  .includes(item?.fancySelectionId) ? (
                                  <span className="">{helpers.currencyFormat(item?.profitAmount.toFixed(2))}</span>
                                ) : (
                                  <span className="text-danger">
                                    ({helpers.currencyFormat(item?.loseAmount.toFixed(2))})
                                  </span>
                                )}
                              </td>
                            ) : (
                              <td className="text-end">
                                {item?.type == "No" ? (
                                  item?.decisionRun < item?.betRun ? (
                                    <span className="">
                                      {helpers.currencyFormat(item?.profitAmount.toFixed(2))}
                                    </span>
                                  ) : (
                                    <span className="text-danger">
                                      ({helpers.currencyFormat(item?.loseAmount.toFixed(2))})
                                    </span>
                                  )
                                ) : item?.decisionRun >= item?.betRun ? (
                                  <span className="">{helpers.currencyFormat(item?.profitAmount.toFixed(2))}</span>
                                ) : (
                                  <span className="text-danger">
                                    ({helpers.currencyFormat(item?.loseAmount.toFixed(2))})
                                  </span>
                                )}
                              </td>
                            )}
                          </tr>
                          {active.includes(item?._id) && (
                            <tr
                              className="expand new-bethistory-slip"
                              id={item?._id}
                            >
                              <td
                                style={{ background: "#e2e8ed" }}
                                colSpan={"2"}
                              ></td>
                              <td
                                colSpan="9"
                                style={{ background: "#e2e8ed" }}
                                className="new-bethistory-slip-td"
                              >
                                <img
                                  class="expand-arrow"
                                  src={require("../../assets/images/transparent.gif")}
                                ></img>
                                <table>
                                  <tbody>
                                    <tr>
                                      <th>Bet Taken</th>
                                      <th>Odds req.</th>
                                      <th>Stake</th>
                                      <th>Liability</th>
                                      <th>Odds Matched</th>
                                    </tr>
                                    <tr
                                      id="txRow0"
                                      style={{ display: "table-row" }}
                                      className="even"
                                    >
                                      <td className="text-end">
                                        {" "}
                                        {moment(item?.timeInserted).format(
                                          "YYYY-MM-DD hh:mm:ss"
                                        )}
                                      </td>
                                      <td className="text-end">
                                        {" "}
                                        {filter.betType === "fancy"
                                          ? item?.betRun + "/" + item?.bhav
                                          : item?.bhav || "N/A"}
                                      </td>{" "}
                                      <td className="text-end">
                                        {" "}
                                        {item?.amount || "N/A"}
                                      </td>
                                      <td className="text-end">
                                        <span className="text-danger">
                                          ({item?.loseAmount})
                                        </span>
                                      </td>
                                      <td className="text-end">
                                        {" "}
                                        {filter.betType === "fancy"
                                          ? item?.betRun + "/" + item?.bhav
                                          : item?.bhav || "N/A"}
                                      </td>{" "}
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          )}
                        </>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="12" className="text-start">
                        <span>You have no bets in this time period.</span>
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
          
           
          </div>
        </div>
      )} */}
    </div>
  );
};
